import { NextStudio } from "next-sanity/studio";

import config from "../../sanity.config";
import { useNavigate } from "react-router-dom";

export default function AdminPage() {
  const navigate = useNavigate();

  if (window.location.pathname.startsWith("/content/desk/")) {
    navigate("/content");
  }
  return (
    <>
      <NextStudio config={config} />
    </>
  );
}
